type IndustryDropdownItem = {
  en: string;
  zh: string;
};

const industries: IndustryDropdownItem[] = [
  {
    en: 'Aerospace & Defense',
    zh: '航天国防',
  },
  {
    en: 'Agriculture & Mining',
    zh: '农矿业',
  },
  {
    en: 'Automotive & Aerospace',
    zh: '汽车',
  },
  {
    en: 'Business Services',
    zh: '商业服务',
  },
  {
    en: 'Computers & Electronics',
    zh: '计算机与电子技术',
  },
  {
    en: 'Consumer Services',
    zh: '消费品',
  },
  {
    en: 'Contingent Workforce',
    zh: '劳务派遣',
  },
  {
    en: 'Education',
    zh: '教育',
  },
  {
    en: 'Energy & Utilities',
    zh: '能源',
  },
  {
    en: 'Engineering',
    zh: '工程技术',
  },
  {
    en: 'Financial Services',
    zh: '金融服务',
  },
  {
    en: 'Food & Beverage',
    zh: '食品饮料',
  },
  {
    en: 'Government',
    zh: '政府',
  },
  {
    en: 'Healthcare, Pharmaceuticals, & Biotech',
    zh: '医疗、医药与生物科学',
  },
  {
    en: 'Insurance',
    zh: '保险',
  },
  {
    en: 'Legal',
    zh: '法律',
  },
  {
    en: 'Manufacturing',
    zh: '制造业',
  },
  {
    en: 'Media & Entertainment',
    zh: '媒体娱乐',
  },
  {
    en: 'Non-Profit',
    zh: '非营利组织',
  },
  {
    en: 'Real Estate & Construction',
    zh: '房地产建筑',
  },
  {
    en: 'Retail',
    zh: '零售',
  },
  {
    en: 'Software & Internet',
    zh: '软件与互联网',
  },
  {
    en: 'Telecommunications',
    zh: '通讯',
  },
  {
    en: 'Transportation & Storage',
    zh: '运输储存',
  },
  {
    en: 'Travel, Recreation & Leisure',
    zh: '旅游、娱乐与休闲',
  },
  {
    en: 'Venture Capitalist',
    zh: '风险投资',
  },
  {
    en: 'Wholesale & Distribution',
    zh: '批发与分销',
  },
];

export default industries;
